import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { RoleListModel } from '../models/RoleListModel';
import { RoleModel } from '../models/RoleModel';
import { AddRoleModel } from '../models/AddRoleModel';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModelResponse } from '../../core/services/ModelResponse';
import { LookupModel } from '../../common/models/LookupModel';
import { SystemRoleType } from '../models/SystemRoleType';
import { SystemPermissionModel } from '../models/SystemPermissionModel';
import { DeleteRoleModel } from '../models/DeleteRoleModel';

@Injectable()
export class RolesService {
  constructor(public httpClient: HttpClient) {}

  getRoleList(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<RoleListModel>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<RoleListModel>>("/api/SecurityModule/Role/ListQuery", { params: params });
  }

  //TODO:move to common security service
  getAvailablePermissions(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<RoleModel>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<RoleModel>>("/api/SecurityModule/Role/GetAvailablePermissionsQuery", { params: params });
  }

  getAssignableRolesForType(roleType: SystemRoleType, page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<RoleModel>> {
    var params = new HttpParams()
      .set('type', roleType)
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<RoleModel>>("/api/SecurityModule/Role/GetAssignableRolesForType", { params: params });
  }

  getRole(key: string): Observable<ModelResponse<RoleModel>> {
    return this.httpClient.get<ModelResponse<RoleModel>>("/api/SecurityModule/Role/Get/" + key);
  }

  addRole(addModel: AddRoleModel): Observable<ModelResponse<string>> {
    return this.httpClient.put<ModelResponse<string>>("/api/SecurityModule/Role/Add/", addModel);
  }

  addIncludedRole(roleKey: string, model: LookupModel): Observable<ModelResponse<LookupModel>> {
    return this.httpClient.put<ModelResponse<LookupModel>>("/api/SecurityModule/Role/" + roleKey + "/IncludedRole/", model);
  }

  removeIncludedRole(roleKey: string, permissionKey: string): Observable<ModelResponse<boolean>> {
    return this.httpClient.delete<ModelResponse<boolean>>("/api/SecurityModule/Role/" + roleKey + "/IncludedRole/" + permissionKey);
  }

  addPermission(roleKey: string, model: SystemPermissionModel): Observable<ModelResponse<LookupModel>> {
    return this.httpClient.put<ModelResponse<LookupModel>>("/api/SecurityModule/Role/" + roleKey + "/Permission/", model);
  }

  removePermission(roleKey: string, permissionKey: string): Observable<ModelResponse<boolean>> {
    return this.httpClient.delete<ModelResponse<boolean>>("/api/SecurityModule/Role/" + roleKey + "/Permission/" + permissionKey);
  }

  reviseName(roleKey: string, model: string): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>("/api/SecurityModule/Role/" + roleKey + "/ReviseName/", { model });
  }

  reviseIsAdministrative(roleKey: string, model: boolean): Observable<ModelResponse<boolean>> {
    return this.httpClient.post<ModelResponse<boolean>>("/api/SecurityModule/Role/" + roleKey + "/ReviseIsAdministrative/", { model });
  }

  reviseDescription(roleKey: string, description: string): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>("/api/SecurityModule/Role/" + roleKey + "/ReviseDescription/", { model: description });
  }
  deleteRole(deleteRoleModel: DeleteRoleModel): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>("/api/SecurityModule/Role/Delete/", deleteRoleModel);
  }

  reviseIsEssential(roleKey: string, model: boolean): Observable<ModelResponse<boolean>> {
    return this.httpClient.post<ModelResponse<boolean>>("/api/SecurityModule/Role/" + roleKey + "/ReviseIsEssential/", { model });
  }
}



// WEBPACK FOOTER //
// ./src/app/security/services/RolesService.ts